'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UiPath = (_temp = _class = function (_SvgIcon) {
  _inherits(UiPath, _SvgIcon);

  function UiPath() {
    _classCallCheck(this, UiPath);

    return _possibleConstructorReturn(this, (UiPath.__proto__ || Object.getPrototypeOf(UiPath)).apply(this, arguments));
  }

  _createClass(UiPath, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2['default'].createElement('path', { d: 'M0 0h64v64H0z' }),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(11 11)' },
              _react2['default'].createElement('path', {
                fill: '#0085CA',
                d: 'M40.188 40.316H1.642V1.706h38.567v38.61h-.021zm1.684.383V1.258C41.872.554 41.318 0 40.614 0H1.258C.554 0 0 .554 0 1.258v39.441c0 .704.554 1.258 1.258 1.258h39.356a1.26 1.26 0 0 0 1.258-1.258z'
              }),
              _react2['default'].createElement('path', {
                fill: '#0085CA',
                d: 'M15.947 34.154c5.778 0 9.402-3.22 9.402-11.448V8.656h-4.221v14.39c0 5.437-2.132 7.228-5.18 7.228-3.007 0-5.032-1.79-5.032-7.227V8.656H6.503v14.05c0 8.229 3.688 11.448 9.444 11.448M33.387 12.067c1.556 0 2.707-1.023 2.707-2.494 0-1.493-1.15-2.516-2.707-2.516s-2.708 1.023-2.708 2.516c0 1.47 1.151 2.494 2.708 2.494'
              }),
              _react2['default'].createElement(
                'mask',
                { id: 'b', fill: '#fff' },
                _react2['default'].createElement('path', { d: 'M0 41.957h41.872V0H0z' })
              ),
              _react2['default'].createElement('path', {
                fill: '#0085CA',
                d: 'M31.17 34.133h4.37V15.35h-4.37z',
                mask: '#b'
              })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return UiPath;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = UiPath;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/UiPath.js
// module id = 1412
// module chunks = 32